/**
 * FAQ Schema Aggregator
 *
 * This script consolidates multiple FAQ section schemas into a single FAQPage schema
 * to prevent "Duplicate field FAQPage" errors in Google Rich Results.
 *
 * How it works:
 * 1. Finds all individual FAQ section schemas (marked with class 'faq-section-schema')
 * 2. Extracts FAQ data from each schema
 * 3. Removes the individual schemas from the DOM
 * 4. Creates one combined FAQPage schema with all items
 * 5. Injects the combined schema into the document head
 */

(function() {
  'use strict';

  // Find all individual FAQ section schemas
  const individualSchemas = document.querySelectorAll('script.faq-section-schema');

  if (individualSchemas.length === 0) {
    console.warn('FAQ Schema Aggregator: No FAQ section schemas found on this page.');
    return;
  }

  // If only one FAQ section exists, no need to aggregate
  if (individualSchemas.length === 1) {
    console.log('FAQ Schema Aggregator: Only one FAQ section found, aggregation not needed.');
    return;
  }

  const allFaqItems = [];

  // Extract FAQ data from each individual schema
  individualSchemas.forEach(schemaScript => {
    try {
      const schemaData = JSON.parse(schemaScript.textContent);

      if (schemaData.mainEntity && Array.isArray(schemaData.mainEntity)) {
        // Validate each FAQ item before adding it
        schemaData.mainEntity.forEach(item => {
          // Only add items that have both question name and answer text
          if (
            item &&
            item['@type'] === 'Question' &&
            item.name &&
            item.name.trim() !== '' &&
            item.acceptedAnswer &&
            item.acceptedAnswer['@type'] === 'Answer' &&
            item.acceptedAnswer.text &&
            item.acceptedAnswer.text.trim() !== ''
          ) {
            allFaqItems.push(item);
          } else {
            console.warn('FAQ Schema Aggregator: Skipped invalid FAQ item:', item);
          }
        });
      }
    } catch (e) {
      console.error('FAQ Schema Aggregator: Error parsing FAQ schema:', e);
    }
  });

  // Only proceed if we have valid FAQ items
  if (allFaqItems.length > 0) {
    const combinedSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": allFaqItems
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'faq-schema-combined';
    script.textContent = JSON.stringify(combinedSchema, null, 2);
    document.head.appendChild(script);

    // Only remove individual schemas after successfully creating the combined one
    individualSchemas.forEach(schemaScript => schemaScript.remove());

    console.log(`FAQ Schema Aggregator: Combined ${allFaqItems.length} FAQ items from ${individualSchemas.length} sections into one schema.`);
  } else {
    console.warn('FAQ Schema Aggregator: No valid FAQ items found in schemas.');
  }
})();
